import { Reveal, Chapter } from "./Reveal";
import { Mail, MessageCircle, Globe, ArrowUpRight } from "lucide-react";
import { waLink, WA_DISPLAY, EMAIL, SITE } from "../data/content";
import { useT } from "../i18n";

const Contact = () => {
  const t = useT();
  return (
    <section id="contact" data-testid="contact-section" className="relative overflow-hidden border-t border-gold/10 bg-[#0B132B] py-24 lg:py-32">
      <div className="pointer-events-none absolute -right-40 top-0 h-[400px] w-[400px] rounded-full bg-gold/10 blur-[140px]" />
      <div className="relative mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-2 lg:gap-20">
          <div>
            <Reveal>
              <Chapter number="08" label={t.contact.label} testid="contact-chapter" />
            </Reveal>
            <Reveal delay={0.1}>
              <h2 data-testid="contact-title" className="mt-8 font-display text-3xl font-semibold leading-tight text-white sm:text-5xl">
                {t.contact.title}
              </h2>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-6 max-w-lg text-sm leading-relaxed text-slate-400 md:text-base">{t.contact.copy}</p>
            </Reveal>
            <Reveal delay={0.26}>
              <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                <a
                  data-testid="contact-whatsapp-button"
                  href={waLink(t.wa.generic)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center justify-center gap-2 bg-[#25D366] px-7 py-4 font-mono text-xs tracking-[0.2em] text-white transition-[box-shadow,transform] duration-300 hover:shadow-[0_0_32px_rgba(37,211,102,0.35)]"
                >
                  <MessageCircle size={16} /> {t.contact.wa.toUpperCase()}
                </a>
                <a
                  data-testid="contact-email-button"
                  href={`mailto:${EMAIL}`}
                  className="group flex items-center justify-center gap-2 border border-gold/60 px-7 py-4 font-mono text-xs tracking-[0.2em] text-gold transition-[background-color,color] duration-300 hover:bg-gold hover:text-[#0B132B]"
                >
                  <Mail size={16} /> {t.contact.cta.toUpperCase()}
                  <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.2}>
            <div className="flex h-full flex-col justify-center gap-6">
              <div className="flex items-center gap-5 border border-slate-800 bg-[#0B0E14]/60 px-6 py-5">
                <Mail size={20} className="shrink-0 text-gold" />
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">{t.contact.emailLabel}</p>
                  <a data-testid="contact-email" href={`mailto:${EMAIL}`} className="mt-1 block text-base text-slate-100 transition-colors duration-300 hover:text-gold">
                    {EMAIL}
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-5 border border-slate-800 bg-[#0B0E14]/60 px-6 py-5">
                <MessageCircle size={20} className="shrink-0 text-gold" />
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">{t.contact.waLabel}</p>
                  <a
                    data-testid="contact-whatsapp"
                    href={waLink(t.wa.generic)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-1 block text-base text-slate-100 transition-colors duration-300 hover:text-gold"
                  >
                    {WA_DISPLAY}
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-5 border border-slate-800 bg-[#0B0E14]/60 px-6 py-5">
                <Globe size={20} className="shrink-0 text-gold" />
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">{t.contact.webLabel}</p>
                  <p data-testid="contact-website" className="mt-1 text-base text-slate-100">{SITE}</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
